/**
 * @generated SignedSource<<fc04657a103c8a58b30f9a4d7cc7ec6b>>
 * @relayHash 8bedad847acb23ef8a700c01aa7acabf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 01e4946d06773573b979ca716708973ac08dbdb6bd246697cdb423bb94b3397c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
  queryContext?: string | null | undefined;
};
export type GoalPanelQuery$data = {
  readonly goals_byId: {
    readonly id: string;
    readonly key: string;
    readonly url: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalCustomFields" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "GoalUpdateComposerCreate" | "ParentGoal" | "SubGoals">;
  };
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "queryContext"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = [
  (v9/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v12 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedGoals"
},
v13 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v14 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v15 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v16 = [
  (v5/*: any*/),
  (v1/*: any*/)
],
v17 = [
  (v1/*: any*/)
],
v18 = {
  "kind": "InlineFragment",
  "selections": (v17/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v19 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "value"
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "TownsquareGoalTypeCustomName"
},
v23 = {
  "kind": "ScalarField",
  "name": "messageId"
},
v24 = {
  "kind": "ScalarField",
  "name": "defaultValue"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v23/*: any*/),
    (v24/*: any*/)
  ],
  "type": "TownsquareLocalizationField"
},
v26 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v22/*: any*/),
    (v25/*: any*/)
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "kind"
},
v28 = {
  "kind": "ScalarField",
  "name": "state"
},
v29 = {
  "kind": "ScalarField",
  "name": "score"
},
v30 = [
  (v20/*: any*/),
  (v29/*: any*/)
],
v31 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v33 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v34 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v35 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v21/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v25/*: any*/)
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v37 = {
  "kind": "ScalarField",
  "name": "type"
},
v38 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v37/*: any*/)
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "subType"
},
v40 = {
  "kind": "ScalarField",
  "name": "archived"
},
v41 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v42 = {
  "kind": "ScalarField",
  "name": "source"
},
v43 = {
  "kind": "ScalarField",
  "name": "time"
},
v44 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    (v1/*: any*/)
  ]
},
v45 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v46 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v30/*: any*/)
},
v47 = {
  "concreteType": "TownsquareMetric",
  "kind": "LinkedField",
  "name": "metric",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v37/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/),
    (v42/*: any*/),
    (v44/*: any*/),
    {
      "args": [
        (v45/*: any*/),
        {
          "kind": "Literal",
          "name": "sort",
          "value": [
            "TIME_ASC"
          ]
        }
      ],
      "concreteType": "TownsquareMetricValueConnection",
      "kind": "LinkedField",
      "name": "values",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareMetricValueEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                (v43/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "origin",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "TownsquareGoalUpdate",
                          "kind": "LinkedField",
                          "name": "goalUpdate",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "TownsquareGoal",
                              "kind": "LinkedField",
                              "name": "goal",
                              "plural": false,
                              "selections": (v17/*: any*/)
                            },
                            (v46/*: any*/),
                            (v1/*: any*/)
                          ]
                        }
                      ],
                      "type": "TownsquareFromGoalUpdate"
                    }
                  ]
                },
                (v1/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
    }
  ]
},
v48 = [
  (v20/*: any*/),
  (v1/*: any*/)
],
v49 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v51 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v52 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v37/*: any*/),
                (v39/*: any*/),
                (v40/*: any*/),
                (v41/*: any*/),
                (v42/*: any*/),
                (v44/*: any*/)
              ]
            },
            (v49/*: any*/),
            (v50/*: any*/),
            (v51/*: any*/)
          ]
        }
      ]
    }
  ]
},
v53 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v1/*: any*/)
  ]
},
v54 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v1/*: any*/)
  ]
},
v55 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "start"
    },
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v56 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v55/*: any*/)
  ]
},
v57 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v58 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v59 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v60 = {
  "kind": "ScalarField",
  "name": "summary"
},
v61 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v62 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v63 = {
  "args": (v57/*: any*/),
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v58/*: any*/),
            (v59/*: any*/),
            (v60/*: any*/),
            (v61/*: any*/),
            (v62/*: any*/),
            (v1/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "updates(first:30)"
},
v64 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v65 = [
  (v64/*: any*/)
],
v66 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v67 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v68 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v69 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v70 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v68/*: any*/),
    (v69/*: any*/)
  ]
},
v71 = {
  "args": (v65/*: any*/),
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
},
v72 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v73 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v74 = [
  (v9/*: any*/),
  (v73/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v1/*: any*/)
],
v75 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v74/*: any*/)
},
v76 = {
  "kind": "ScalarField",
  "name": "label"
},
v77 = {
  "kind": "ScalarField",
  "name": "description"
},
v78 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v79 = [
  (v9/*: any*/),
  (v3/*: any*/),
  (v2/*: any*/),
  (v1/*: any*/)
],
v80 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v79/*: any*/)
},
v81 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v79/*: any*/)
},
v82 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v83 = [
  (v62/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v20/*: any*/),
      (v29/*: any*/),
      (v76/*: any*/)
    ]
  },
  (v60/*: any*/),
  {
    "kind": "LinkedField",
    "name": "creator",
    "plural": false,
    "selections": (v74/*: any*/)
  },
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v60/*: any*/),
              (v77/*: any*/),
              (v40/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v1/*: any*/),
              (v60/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v62/*: any*/),
              (v82/*: any*/)
            ]
          }
        ]
      },
      (v19/*: any*/)
    ]
  },
  (v1/*: any*/)
],
v84 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v83/*: any*/)
},
v85 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "newValue",
  "plural": false,
  "selections": (v48/*: any*/)
},
v86 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v77/*: any*/)
],
v87 = [
  (v45/*: any*/)
],
v88 = [
  (v76/*: any*/),
  (v55/*: any*/)
],
v89 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v36/*: any*/)
  ]
},
v90 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/),
                (v73/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v61/*: any*/),
            (v62/*: any*/)
          ]
        }
      ]
    },
    (v19/*: any*/)
  ]
},
v91 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v60/*: any*/),
      (v77/*: any*/),
      (v80/*: any*/),
      (v81/*: any*/),
      (v62/*: any*/),
      (v82/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v92 = [
  (v64/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v4/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "args": (v8/*: any*/),
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalCustomFields"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalUpdateComposerCreate"
            }
          ]
        },
        "action": "THROW",
        "path": "goals_byId"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          },
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v12/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              (v13/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedProjects"
              },
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddJiraAlignItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveJiraAlignItems"
              }
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v16/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v16/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v18/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalIcon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "appearance"
              }
            ]
          },
          (v2/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v26/*: any*/),
              (v1/*: any*/),
              (v27/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          },
          (v31/*: any*/),
          (v32/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v33/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v34/*: any*/),
              {
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v22/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*: any*/),
                      (v23/*: any*/)
                    ],
                    "type": "TownsquareLocalizationField"
                  }
                ]
              },
              (v1/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v35/*: any*/),
                  (v1/*: any*/),
                  (v28/*: any*/)
                ]
              },
              (v27/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          (v38/*: any*/),
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v47/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v1/*: any*/),
                      (v33/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      (v52/*: any*/),
                      (v6/*: any*/),
                      (v31/*: any*/),
                      (v2/*: any*/),
                      (v53/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      (v54/*: any*/),
                      (v56/*: any*/),
                      (v63/*: any*/),
                      (v32/*: any*/),
                      {
                        "args": (v65/*: any*/),
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v66/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              (v67/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          (v70/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": "projects(first:200)"
                      },
                      (v71/*: any*/)
                    ]
                  }
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "args": (v72/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v35/*: any*/),
                          (v1/*: any*/),
                          (v34/*: any*/)
                        ]
                      },
                      (v1/*: any*/),
                      (v33/*: any*/),
                      (v2/*: any*/),
                      (v40/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v47/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v6/*: any*/),
                      (v32/*: any*/),
                      (v56/*: any*/),
                      (v75/*: any*/),
                      (v84/*: any*/),
                      (v15/*: any*/),
                      (v31/*: any*/),
                      {
                        "args": (v57/*: any*/),
                        "concreteType": "TownsquareGoalUpdateConnection",
                        "kind": "LinkedField",
                        "name": "updates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v1/*: any*/),
                                  (v46/*: any*/),
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                                    "kind": "LinkedField",
                                    "name": "metricUpdate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalMetricUpdateEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareGoalMetricUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetric",
                                                "kind": "LinkedField",
                                                "name": "metric",
                                                "plural": false,
                                                "selections": (v17/*: any*/)
                                              },
                                              (v85/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "updates(first:30)"
                      },
                      (v5/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              (v55/*: any*/),
              {
                "kind": "ScalarField",
                "name": "confidence"
              }
            ]
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v1/*: any*/),
              (v38/*: any*/),
              (v52/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v21/*: any*/)
              },
              (v2/*: any*/),
              (v53/*: any*/),
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v12/*: any*/)
                ]
              },
              (v15/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v77/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v69/*: any*/),
                  (v68/*: any*/)
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          (v62/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v86/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v18/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          }
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v86/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v18/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          }
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v86/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v18/*: any*/)
                            ]
                          },
                          {
                            "args": (v87/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v2/*: any*/),
                                      (v3/*: any*/)
                                    ]
                                  },
                                  (v67/*: any*/)
                                ]
                              },
                              (v70/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v87/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          }
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v77/*: any*/),
                                  {
                                    "args": (v87/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v20/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v18/*: any*/)
                            ]
                          },
                          {
                            "args": (v87/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v67/*: any*/)
                                ]
                              },
                              (v70/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v87/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          }
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v40/*: any*/),
          {
            "args": (v57/*: any*/),
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v60/*: any*/),
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v60/*: any*/),
                                  (v77/*: any*/),
                                  (v1/*: any*/),
                                  (v40/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v62/*: any*/),
                      (v46/*: any*/),
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v37/*: any*/),
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      (v42/*: any*/),
                                      (v44/*: any*/)
                                    ]
                                  },
                                  (v85/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v48/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v58/*: any*/),
                      (v59/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v1/*: any*/),
                          (v73/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v88/*: any*/)
                      },
                      {
                        "args": (v72/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v89/*: any*/),
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v52/*: any*/),
                                  (v6/*: any*/),
                                  (v32/*: any*/),
                                  (v56/*: any*/),
                                  (v75/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v83/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v73/*: any*/),
                          (v2/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      (v61/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v73/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v17/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v17/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v60/*: any*/),
                                  (v77/*: any*/),
                                  (v9/*: any*/),
                                  (v1/*: any*/),
                                  (v78/*: any*/),
                                  (v80/*: any*/),
                                  (v81/*: any*/),
                                  (v62/*: any*/),
                                  (v82/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v19/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v32/*: any*/),
                          (v40/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v26/*: any*/),
                                  (v35/*: any*/),
                                  (v1/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          },
                          {
                            "args": (v72/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v40/*: any*/),
                                      (v38/*: any*/),
                                      (v52/*: any*/),
                                      (v6/*: any*/),
                                      (v32/*: any*/),
                                      (v56/*: any*/),
                                      (v75/*: any*/),
                                      (v84/*: any*/),
                                      (v15/*: any*/),
                                      (v33/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v26/*: any*/),
                                          (v35/*: any*/),
                                          (v34/*: any*/),
                                          (v1/*: any*/)
                                        ]
                                      },
                                      (v31/*: any*/),
                                      (v63/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "args": (v57/*: any*/),
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v60/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v60/*: any*/),
                                                  (v77/*: any*/),
                                                  (v1/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:30)"
                          },
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          (v40/*: any*/)
                                        ]
                                      },
                                      (v1/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v33/*: any*/),
                                      (v89/*: any*/),
                                      (v53/*: any*/),
                                      (v31/*: any*/),
                                      (v54/*: any*/),
                                      (v56/*: any*/),
                                      (v63/*: any*/),
                                      (v32/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v90/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v30/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v88/*: any*/)
                      }
                    ]
                  }
                ]
              },
              (v19/*: any*/)
            ],
            "storageKey": "updates(first:30)"
          },
          (v77/*: any*/),
          (v90/*: any*/),
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "args": (v65/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v67/*: any*/),
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v66/*: any*/)
                    ]
                  }
                ]
              },
              (v70/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": "projects(first:200)"
          },
          (v71/*: any*/),
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v91/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v91/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v91/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "args": (v92/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "workItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v5/*: any*/),
                          (v60/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v18/*: any*/)
                    ]
                  },
                  (v67/*: any*/),
                  (v1/*: any*/)
                ]
              },
              (v70/*: any*/),
              (v19/*: any*/)
            ]
          },
          {
            "args": (v92/*: any*/),
            "filters": [
              "queryContext"
            ],
            "handle": "connection",
            "key": "GoalContentJira_workItems",
            "kind": "LinkedHandle",
            "name": "workItems"
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v18/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "01e4946d06773573b979ca716708973ac08dbdb6bd246697cdb423bb94b3397c",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aff0ec12cadf172d9b6264d6e43003ad";

export default node;
